import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";
import {
    FETCH_GENERATED_REPORTS_API

} from "../constants/urls";

export const backgroundJobsService = {
    fetchReportingJobs
}

async function fetchReportingJobs() {
    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}${FETCH_GENERATED_REPORTS_API}`,
        "GET",
        null,
        false
    );

    return await handleResponse(response);
}

async function handleResponse(response) {
    try {
        const text = await response.text();
        const body = text ? JSON.parse(text) : null;

        if (body?.status?.toLowerCase() === 'success') {
            return body.payload;
        } else {
            return Promise.reject(body.error || { message: 'Some error occured. '});
        }
    } catch (error) {
        return Promise.reject({ message: 'Some error occured. '})
    }
}